/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Name_RequiredInputs */



/**
* | output |
* | --- |
* | "Tournament name cannot be empty" |
*
* @param {Err_Tournament_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_name_required = /** @type {((inputs?: Err_Tournament_Name_RequiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Name_RequiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le nom du tournoi ne peut pas être vide")
	if (locale === "es") return /** @type {LocalizedString} */ ("El nombre del torneo no puede estar vacío")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O nome do torneio não pode estar vazio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il nome del torneo non può essere vuoto")
	return /** @type {LocalizedString} */ ("Tournament name cannot be empty")
});